const CLEANLINESS_OPTIONS = ["Clean", "Dirty", "Dusty", "Greasy", "Moldy", "Rusted"];
const DAMAGE_OPTIONS = ["Undamaged", "Damaged", "Wear & Tear", "Broken", "Cracked", "Stained"];
const FUNCTIONING_OPTIONS = ["Working", "Not Working", "Faulty"];

module.exports = {

    data () {
        return {
            CLEANLINESS_OPTIONS: CLEANLINESS_OPTIONS,
            DAMAGE_OPTIONS: DAMAGE_OPTIONS,
            FUNCTIONING_OPTIONS: FUNCTIONING_OPTIONS,
        };
    },

    methods: {

        fetchRecommendations (queryString, cb) {
            cb(this.state.currentTeam.inspection_settings.recommendations.map(r => {return {"value": r};}));
        }

    }

};